import { defineStore } from 'pinia'
import axios from 'axios'
import axiosRetry from 'axios-retry'
import encrypter from 'crypto-js'
//import { useRouter } from 'vue-router'
import { useUserStore } from './user'
import { useFirebaseStore } from './firebase'

export const useRequesterStore = defineStore('requester', () => {
  //const router = useRouter()
  const userX = useUserStore()
  const { logout } = useFirebaseStore()
  const deffaultHeader = {
    'Content-Type': 'application/json',
  }

  const client = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    timeout: 60000,
    transformRequest: [
      function (data, headers) {
        if (data) {
          if (!headers.get('isPublic')) {
            const crypted = encrypter.AES.encrypt(JSON.stringify(data), userX.key).toString()
            const dataToSend = { data: crypted }
            return JSON.stringify(dataToSend)
          } else {
            const crypted = encrypter.AES.encrypt(JSON.stringify(data), import.meta.env.VITE_CRIPTO_KEY).toString()
            const dataToSend = { data: crypted }
            return JSON.stringify(dataToSend)
          }
        } else {
          return data
        }
      },
    ],
    transformResponse: [
      function (data, headers) {
        try {
          if (!data) {
            return { error: 'emptyData', data }
          }
          let dataObj
          if (!headers.get('isPublic')) {
            dataObj = JSON.parse(encrypter.AES.decrypt(data, userX.key).toString(encrypter.enc.Utf8))
          } else {
            dataObj = JSON.parse(
              encrypter.AES.decrypt(data, import.meta.env.VITE_CRIPTO_KEY).toString(encrypter.enc.Utf8),
            )
          }
          return dataObj ?? data
        } catch (error) {
          return { error: 'decryptError', data }
        }
      },
    ],
  })

  client.interceptors.response.use(
    (response: any) => {
      return response
    },
    async (error: any) => {
      const origitalRequest = error.config
      if (error.response) {
        if (error.response.status === 403 && !origitalRequest._retry) {
          try {
            origitalRequest._retry = true

            const { data } = await Post({
              route: '/auth/refresh-token',
              body: {
                token: userX.token,
                refreshToken: userX.refreshToken,
              },
              extraHeader: {
                isPublic: true,
              },
            })
            userX.setTokens({
              key: data.key,
              token: data.token,
              refreshToken: data.refreshToken,
            })

            return client(origitalRequest)
          } catch (_error) {
            return Promise.reject(_error)
          }
        } else if (error.response.status === 401) {
          //redirect to login page when 401 is received
          userX.setApiUser(null)
          await logout()
          window.location.reload()
        }
      }
      return Promise.reject(error)
    },
  )

  axiosRetry(client, {
    retries: 3,
    retryDelay: axiosRetry.exponentialDelay,
    retryCondition: (e: any) => {
      return e.response?.status === 403
    },
  })
  const outClient = axios.create()
  function makeHeader(withAuth: boolean, extraHeader: {}) {
    return {
      ...deffaultHeader,
      ...(withAuth
        ? {
            Authorization: 'Bearer ' + userX.token,
          }
        : {}),
      ...extraHeader,
    }
  }
  function Get({ route = '', withAuth = false, extraHeader = {}, external = false, params = {} }) {
    const cli = external ? outClient : client
    return cli.get(route, { headers: makeHeader(withAuth, extraHeader), params })
  }

  function Put({ route = '', withAuth = false, extraHeader = {}, body = {}, external = false }) {
    const cli = external ? outClient : client
    return cli.put(route, body, { headers: makeHeader(withAuth, extraHeader) })
  }

  function Post({ route = '', withAuth = false, extraHeader = {}, body = {}, external = false }) {
    const cli = external ? outClient : client
    return cli.post(route, body, {
      headers: makeHeader(withAuth, extraHeader),
    })
  }

  function Delete({ route = '', withAuth = false, extraHeader = {}, external = false }) {
    const cli = external ? outClient : client
    return cli.delete(route, { headers: makeHeader(withAuth, extraHeader) })
  }

  return { client, outClient, Get, Put, Post, Delete }
})
